import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InsightsState } from 'app-redux/InsightsState';
import { nameof } from 'utils/typeHelpers';
import * as dto from 'client/dto';

export type AdminState = {
  isLoading: boolean;
  users: dto.UserModel[];
  emailTypes: dto.EmailTypeModel[];
  customDiseaseGroups: dto.CustomDiseaseGroup[];
  customDiseaseRelevance: dto.DiseaseGroupModel[];
};

export const InitialAdminState: AdminState = {
  isLoading: false,
  users: [],
  emailTypes: [],
  customDiseaseGroups: [],
  customDiseaseRelevance: [],
};

const adminSlice = createSlice({
  name: nameof<InsightsState>('admin'),
  initialState: InitialAdminState,
  reducers: {
    startAdminLoading: state => {
      state.isLoading = true;
    },
    finishAdminLoading: state => {
      state.isLoading = false;
    },
    setUsers: (state, action: PayloadAction<dto.UserModel[]>) => {
      state.users = action.payload;
    },
    setEmailTypes: (state, action: PayloadAction<dto.EmailTypeModel[]>) => {
      state.emailTypes = action.payload;
    },
    setCustomDiseaseGroups: (state, action: PayloadAction<dto.CustomDiseaseGroup[]>) => {
      state.customDiseaseGroups = action.payload;
    },
    userSaveSuccess: (state, action: PayloadAction<dto.UserModel>) => {
      const existingUserIndex = state.users.findIndex(user => user.id === action.payload.id);
      if (existingUserIndex !== -1) state.users[existingUserIndex] = action.payload;
      else state.users = [...state.users, action.payload];
    },
    setCustomDiseaseRelevance: (state, action: PayloadAction<dto.DiseaseGroupModel[]>) => {
      state.customDiseaseRelevance = action.payload;
    },
  },
});

const { actions, reducer } = adminSlice;

export const {
  startAdminLoading,
  finishAdminLoading,
  setUsers,
  setEmailTypes,
  setCustomDiseaseGroups,
  userSaveSuccess,
  setCustomDiseaseRelevance,
} = actions;

export default reducer;
